import GameBoard from "./GameBoard";
import Header from './Header'

function Tictactoe() {
    return (
      <>
        <Header heading = "TIC-TAC-TOE"/>
        <GameBoard/>
      </>
    );
  }
  
  export default Tictactoe;
  